var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1552 1585",
    width: 1552,
    height: 1585,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SBS_BIG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #0093dd } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m1551.5 422l0.2-23.7v-353c0 0-330.6-125.8-626.2 45.5-295.7 171.4-345.3 392.9-345.3 392.9 0 0-47 165.8-53.5 228.3-6 62.8-4.9 60-4.9 60l0.5 6.3-0.5 8.7h1028c-231-82.3-321.6-116.2-429.9-210-139.9-133.1-84-273.9-33-339.9 111.6-143.8 309.4-114.1 392.3 25.9 13.1 21.8 26.2 42.8 33.2 58.6 20.2 33.9 29 57.9 39.1 100.4zm-1551.2-420.4v846c0 0 0.8 16.1 4.6 43.4 18 126 103.1 492.7 489.3 640.5 428.5 164.3 796-82.4 948.4-340.7 97.4-165.1 105.9-377.6 105.9-377.6h-1024c0 0 4.4 8.5 12.3 12.3 41.7 19.4 181.9 78.3 266.2 115.1 164.7 72.1 204 111.9 222.6 203.5 25.3 126.6-48.8 204.7-74.5 229.5-69.5 66.8-121.9 69.3-186.3 70.1-165.8 2.2-237.6-132.3-244.4-216.3-3-37.7 0-1225.2 0-1225.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbs);
export default __webpack_public_path__ + "static/media/SBS.e24757cf18fb0a24f527facf868ddce3.svg";
export { ForwardRef as ReactComponent };